import { IViewerApi } from "@bronte/viewer-api/src/IViewerApi";
import { SpotlightAPI } from "@bronte/viewer-api/src/shared/types";

/** Avoid throwing when WEB viewer CDP services are not ready (e.g. exportId offline package). */
export function getSpotlightApi(viewerApi: IViewerApi | undefined): SpotlightAPI | null {
  if (!viewerApi?.spotlight) {
    return null;
  }
  try {
    return viewerApi.spotlight();
  } catch {
    return null;
  }
}
